<template>
  <div>
    <div class="sub-header-container">
      <div class="sub-header-content" style="justify-content: center;">
        <div class="page-title-container" style="padding-top:40px; padding-bottom: 40px;">
          <h1 style="text-align: center; padding-top: 20px; padding-bottom: 20px; color: var(--secondary-text-color);">Oh no! Page not found 😨</h1>
        </div>
      </div>
    </div>

    <div class="page-container">
      <div style="display: flex; justify-content: center;">
        <p style="font-size: 20px;">Sorry, we couldn't find this page. But don't worry, you can find awesome Twitter threads <router-link to="/">here.</router-link></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {

  },
}
</script>

<style>
.header-container{
  background-color: var(--global-header-color);
  max-width: 1100px;
  padding: 10px 3rem 10px 3rem;
  margin: 0 auto;
}
.sub-header-container{
  background-color: transparent;
  max-width: 1100px;
  padding: 0 3rem;
  margin: 0 auto 10px auto;
}
.page-container{
  max-width: 1100px;
  min-height: 1100px;
  padding: 0 3rem;
  margin: 0 auto;
}
@media (max-width: 760px){
  .header-container{
  padding: 0 0.5rem;
  }
  .sub-header-container{
  padding: 0 0.5rem;
  }
  .page-container{
  padding: 0 0.5rem;
  }
  .website-name{
    font-size: 15px;
  }
   .website-name-container img{
    width: 22px;
  }
  .website-name-container p{
    display: none;
  }
}
</style>>